// extracted by mini-css-extract-plugin
export default {"worksiteDesktop":"worksiteDesktop_worksiteDesktop__fU+X3","content":"worksiteDesktop_content__YYKbE"};